// Load before other app imports: some dev tooling or deps reference `process` at runtime
// before CRA's DefinePlugin-inlined env is enough for every code path.
if (typeof window !== "undefined" && window.process == null) {
  window.process = { env: {} };
}
